// eslint-disable-next-line

export default {
  body: document.body,
  html: document.documentElement,
  mediumBreakpoint: 768,
};



// WEBPACK FOOTER //
// ./src/scripts/modules/globals.js